import { render } from "./App.vue?vue&type=template&id=5aa45b55"
const script = {}

import "./App.vue?vue&type=style&index=0&id=5aa45b55&lang=less"

import exportComponent from "C:\\REPOS\\pwd-reset\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__